import getCharts from '../getCharts'
import { MedicationMaster } from '../../constants/api.config'

export default async function MedicineCRUD(mode="GET" , id="", data="") {
  try {
    const payload = {mode,id,data}
    const res = await getCharts(MedicationMaster, payload)
    return res.data
  } catch (error) {
    return error
  }
}
